import { FC } from "react";
import { IconPropsType } from ".";

export const CreditCard: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.9641 10.8376C1.52922 11.6661 1.0376 13.5008 1.86602 14.9357L5.51638 21.2583C6.34481 22.6932 8.17958 23.1848 9.61446 22.3564L21.6897 15.3848C23.1246 14.5563 23.6162 12.7216 22.7878 11.2867L21.5 9L22 8L23.6538 10.7867C24.7584 12.6999 24.1028 15.1462 22.1897 16.2508L10.1145 23.2224C8.20129 24.327 5.75492 23.6715 4.65035 21.7583L0.999998 15.4357C-0.104571 13.5225 0.550931 11.0762 2.4641 9.97162L7 7.5L7 8.5L2.9641 10.8376Z"
        fill={props.color}
      />
      <path
        d="M1.5 15L8 11.5L9 12L2.07447 15.9574L2.5 16.6667L10.5 12.5L11.5 13L3 17.5L2.5 16.6667L2 16L2.07447 15.9574L1.5 15Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 11C17.7614 11 20 8.76142 20 6C20 3.23858 17.7614 1 15 1C12.2386 1 10 3.23858 10 6C10 8.76142 12.2386 11 15 11ZM15 12C18.3137 12 21 9.31371 21 6C21 2.68629 18.3137 0 15 0C11.6863 0 9 2.68629 9 6C9 9.31371 11.6863 12 15 12Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4862 6.72741L11.9443 5.03217L12.8083 5.48032C12.4711 6.81923 13.2832 8.17796 14.6221 8.51514C15.3015 8.68624 15.9852 8.56186 16.5394 8.22208L17.0621 9.07462C16.2878 9.54926 15.3288 9.72435 14.3779 9.48486C13.013 9.14116 12.0392 8.03922 11.7928 6.74186L11.2443 7.37951L10.4862 6.72741Z"
        fill={props.color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7842 5.51609L18.3007 7.18912L17.4436 6.72797C17.801 5.39431 17.0095 4.02347 15.6758 3.66611C14.9991 3.48477 14.3136 3.59882 13.7543 3.93019L13.2446 3.06985C14.0259 2.60696 14.9874 2.44637 15.9347 2.70019C17.2942 3.06446 18.2512 4.18097 18.478 5.48191L19.036 4.85262L19.7842 5.51609Z"
        fill={props.color}
      />
    </svg>
  );
};
